<template>
    <div class="excursions-section">
        <div class="section-container container main-container">
            <div class="excursions-section__header">
                <div class="excursions-section__header-projects header-projects">
                    <span>04</span>
                    <div class="border-center"></div>
                    <span>Проекты</span>
                </div>

                <div class="excursions-section__header-title title welcome__title title--m title--uppercase section__header-title--spacing">
                    <span>Экскурсии</span>
                </div>

                <div class="section__header-description section__header-description--w-55 excursions-section__header-description">
                    <div class="hero__text">
                        Памятные места можно объединить в единую экскурсию с маршрутом, описанием и заглавной страницей.
                    </div>
                </div>
            </div>

            <div class="excursions-section__body">
                <div class="excursions-section__content">
                    <div class="excursions-section__content-left">
                        <div class="excursions-section__image-wrapper excursions-section__image-wrapper--top">
                            <img src="/assets/front/img/excursions-sections--ex1.png" alt="img">
                        </div>

                        <div class="excursions-section__image-wrapper excursions-section__image-wrapper--middle">
                            <img src="/assets/front/img/excursions-section--ex2.png" alt="img">
                        </div>

                        <div class="excursions-section__image-wrapper excursions-section__image-wrapper--bottom">
                            <img src="/assets/front/img/excursions-section--ex3.png" alt="img">
                        </div>

                        <div class="excursions-section__arrow-wrapper">
                            <img src="/assets/front/img/excursions-arrow--left.svg" alt="img">
                        </div>
                    </div>

                    <div class="excursions-section__content-right">
                        <div class="excursions-section__content-header hero__text">
                            <span>1. Цифровая экскурсия «Печаль, одетая в гранит»</span>
                        </div>

                        <div class="excursions-section__content-body hero__text">
                            <span>Экскурсия рассказала об истории создания и художественном оформлении Пискарёвского мемориала. Люди могли самостоятельно пройти экскурсию с помощью QR-кодов, расположенных по всей территории мемориала.</span>
                        </div>

                        <div class="excursions-section--btn-wrapper">
                            <a class="btn btn--w100 btn--main-bg btn--middle" @click="routeToLink('https://piskarevskiy-memorial.ru/')">Узнать больше</a>
                        </div>

                        <div class="excursions-section__content-footer">
                            <div class="excursions-section__icon-wrapper">
                                <svg class="excursions-section__content-quotes">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-quote"></use>
                                </svg>
                            </div>

                            <div class="excursions-section__content-footer__description">
                                <span>Благодаря новому проекту «Код памяти: Пискаревский мемориал» и современным технологиям петербуржцы и гости города смогли побывать на Пискаревском мемориале, не выходя из дома</span>
                            </div>

                            <div class="excursions-section__content-footer__author">
                                <div class="author__image-wrapper">
                                    <img src="/assets/front/img/excursions/author-image--beglov.png" alt="img">
                                </div>

                                <div class="excursions-section__author__title">
                                    <span class="excursions-section__author__name">Беглов Александр Дмитриевич</span>
                                    <span class="excursions-section__author__personality">Губернатор Санкт-Петербурга</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="excursions-section__content excursions-section__content--bottom">
                    <div class="excursions-section__content-left">
                        <div class="excursions-section__content-header hero__text">
                            <span>2. Программа «Белый Тополь»</span>
                        </div>

                        <div class="excursions-section__content-body hero__text">
                            <span>«Белый Тополь» – уникальная для России мемориальная программа, опыт которой сегодня востребован в соседних регионах и за рубежом. Направлена на сохранение памяти о выдающихся людях, чья судьбы была связана с Новосибирском.</span>
                        </div>

                        <div class="excursions-section__benefits-wrapper">
                            <div class="excursions-section__benefit-block">
                                <div class="excursions-section__benefit-icon">
                                    <img src="/assets/front/img/checked-icon.svg" alt="img">
                                </div>

                                <div class="excursions-section__benefit-description excursions-section__benefit-description--mb3">
                                    <span>Каждый объект экскурсии содержит QR-код с подробным описанием</span>
                                </div>
                            </div>

                            <div class="excursions-section__benefit-block">
                                <div class="excursions-section__benefit-icon">
                                    <img src="/assets/front/img/checked-icon.svg" alt="img">
                                </div>

                                <div class="excursions-section__benefit-description">
                                    <span>Бесплатно для всех</span>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section--btn-wrapper">
                            <a class="btn btn--w100 btn--main-bg btn--middle" @click="routeToLink('http://digitaltour.tilda.ws/beltopol')">Узнать больше</a>
                        </div>

                        <div class="excursions-section__content-footer">
                            <div class="excursions-section__icon-wrapper">
                                <svg class="excursions-section__content-quotes">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-quote"></use>
                                </svg>
                            </div>

                            <div class="excursions-section__content-footer__description excursions-section__content-footer__description--w67">
                                <span>Сегодня особенно важно беречь память о славных и трагических страницах нашей истории, о наших выдающихся земляках. И я уверен, что мое мнение разделяют многие жители Новосибирска.</span>
                            </div>

                            <div class="excursions-section__content-footer__author">
                                <div class="author__image-wrapper">
                                    <img src="/assets/front/img/excursions/author-image--bondarenko.png" alt="img">
                                </div>

                                <div class="excursions-section__author__title">
                                    <span class="excursions-section__author__name">Бондаренко Сергей Валентинович</span>
                                    <span class="excursions-section__author__personality">Депутат Совета депутатов г.Новосибирска</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="excursions-section__content-right excursions-section__content-right--transform">
                        <div class="excursions-section__page">
                            <div class="excursions-section__page-image-wrapper">
                                <img src="/assets/front/img/excursions/page-ex1.png" alt="img">
                            </div>

                            <div class="excursions-section__page-content">
                                <div class="excursions-section__page-name">
                                    <span>Екатерина Савинова </span>
                                </div>

                                <div class="excursions-section__page-description">
                                    <span>Талантливая советская киноактриса, прославившаяся ролями в фильмах «Приходите завтра», «В один прекрасный день»</span>
                                </div>

                                <div class="excursions-section__page-link">
                                    <a class="btn link main-page__link btn--w100 places-section__btn" @click="routeToLink('/page/20946870')">Смотреть страницу</a>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section__page excursions-section__page--left">
                            <div class="excursions-section__page-image-wrapper">
                                <img src="/assets/front/img/excursions/page-ex2.png" alt="img">
                            </div>

                            <div class="excursions-section__page-content excursions-section__page-content--w60">
                                <div class="excursions-section__page-name">
                                    <span>Яна Дягилева </span>
                                </div>

                                <div class="excursions-section__page-description">
                                    <span>Советская рок-певица, автор-исполнитель, участница панк-рок-группы «Гражданская оборона»</span>
                                </div>

                                <div class="excursions-section__page-link">
                                    <a class="btn link main-page__link btn--w100 places-section__btn" @click="routeToLink('/page/44647376')">Смотреть страницу</a>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section__arrow-wrapper--right">
                            <img src="/assets/front/img/excursions-arrow--right.svg" alt="img">
                        </div>
                    </div>
                </div>
            </div>

<!--мобильная версия-->
            <div class="excursions-section__body--mobile">
                <div class="excursions-section__content--mobile">
                    <div class="excursions-section__content-right--mobile">
                        <div class="excursions-section__content-header hero__text">
                            <span>1. Цифровая экскурсия «Печаль, одетая в гранит»</span>
                        </div>

                        <div class="excursions-section__content-body hero__text">
                            <span>Экскурсия рассказала об истории создания и художественном оформлении Пискарёвского мемориала. Люди могли самостоятельно пройти экскурсию с помощью QR-кодов, расположенных по всей территории мемориала.</span>
                        </div>

                        <div class="excursions-section__content-left--mobile">
                            <div class="excursions-section__image-wrapper--mobile excursions-section__image-wrapper--top">
                                <img class="excursions-section__image--mobile" src="/assets/front/img/excursions-sections--ex1-mobile.png" alt="img">
                            </div>
                        </div>

                        <div class="excursions-section__content-footer--mobile">
                            <div class="excursions-section__icon-wrapper">
                                <svg class="excursions-section__content-quotes">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-quote"></use>
                                </svg>
                            </div>

                            <div class="excursions-section__content-footer__description--mobile">
                                <span>Благодаря новому проекту «Код памяти: Пискаревский мемориал» и современным технологиям петербуржцы и гости города смогли побывать на Пискаревском мемориале, не выходя из дома</span>
                            </div>

                            <div class="excursions-section__content-footer__author excursions-section__content-footer__author--mobile">
                                <div class="author__image-wrapper">
                                    <img src="/assets/front/img/excursions/author-image--beglov.png" alt="img">
                                </div>

                                <div class="excursions-section__author__title">
                                    <span class="excursions-section__author__name">Беглов Александр Дмитриевич</span>
                                    <span class="excursions-section__author__personality">Губернатор Санкт-Петербурга</span>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section--btn-wrapper">
                            <a class="btn btn--w100 btn--main-bg btn--middle" @click="routeToLink('https://piskarevskiy-memorial.ru/')">Узнать больше</a>
                        </div>
                    </div>
                </div>

                <div class="excursions-section__content--mobile">
                    <div class="excursions-section__content-left--mobile">
                        <div class="excursions-section__content-header hero__text">
                            <span>2. Программа «Белый Тополь»</span>
                        </div>

                        <div class="excursions-section__content-body hero__text">
                            <span>«Белый Тополь» – уникальная для России мемориальная программа, опыт которой сегодня востребован в соседних регионах и за рубежом. Направлена на сохранение памяти о выдающихся людях, чья судьбы была связана с Новосибирском.</span>
                        </div>

                        <div class="excursions-section__benefits-wrapper">
                            <div class="excursions-section__benefit-block">
                                <div class="excursions-section__benefit-icon">
                                    <img src="/assets/front/img/checked-icon.svg" alt="img">
                                </div>

                                <div class="excursions-section__benefit-description excursions-section__benefit-description--mobile excursions-section__benefit-description--mb3">
                                    <span>Каждый объект экскурсии содержит QR-код с подробным описанием</span>
                                </div>
                            </div>

                            <div class="excursions-section__benefit-block">
                                <div class="excursions-section__benefit-icon">
                                    <img src="/assets/front/img/checked-icon.svg" alt="img">
                                </div>

                                <div class="excursions-section__benefit-description">
                                    <span>Бесплатно для всех</span>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section__content-right--mobile">
                            <div class="excursions-section__page--mobile excursions-section__page--mb6">
                                <div class="excursions-section__page-image-wrapper">
                                    <img class="excursions-section__image--mobile excursions-section__image--cover" src="/assets/front/img/excursions/page-ex1--mobile.png" alt="img">
                                </div>

                                <div class="excursions-section__page-content excursions-section__page-content--mobile">
                                    <div class="excursions-section__page-name">
                                        <span>Екатерина Савинова </span>
                                    </div>

                                    <div class="excursions-section__page-description excursions-section__page-description--fs16">
                                        <span>Талантливая советская киноактриса, прославившаяся ролями в фильмах «Приходите завтра», «В один прекрасный день»</span>
                                    </div>
                                </div>

                                <div class="excursions-section__page-link">
                                    <a class="btn link main-page__link btn--w100 places-section__btn" @click="routeToLink('page/20946870')">Смотреть страницу</a>
                                </div>
                            </div>

                            <div class="excursions-section__page--mobile excursions-section__page--mb6">
                                <div class="excursions-section__page-image-wrapper--small">
                                    <img class="excursions-section__image--mobile" src="/assets/front/img/excursions/page-ex2--mobile.png" alt="img">
                                </div>

                                <div class="excursions-section__page-content excursions-section__page-content--mobile excursions-section__page-content--w60">
                                    <div class="excursions-section__page-name">
                                        <span>Яна Дягилева </span>
                                    </div>

                                    <div class="excursions-section__page-description excursions-section__page-description--fs16">
                                        <span>Советская рок-певица, автор-исполнитель, участница панк-рок-группы «Гражданская оборона»</span>
                                    </div>
                                </div>

                                <div class="excursions-section__page-link">
                                    <a class="btn link main-page__link btn--w100 places-section__btn" @click="routeToLink('/page/44647376')">Смотреть страницу</a>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section__content-footer">
                            <div class="excursions-section__icon-wrapper">
                                <svg class="excursions-section__content-quotes">
                                    <use xlink:href="/assets/front/img/sprite.svg#icon-quote"></use>
                                </svg>
                            </div>

                            <div class="excursions-section__content-footer__description--mobile">
                                <span>Сегодня особенно важно беречь память о славных и трагических страницах нашей истории, о наших выдающихся земляках. И я уверен, что мое мнение разделяют многие жители Новосибирска.</span>
                            </div>

                            <div class="excursions-section__content-footer__author excursions-section__content-footer__author--mobile">
                                <div class="author__image-wrapper">
                                    <img src="/assets/front/img/excursions/author-image--bondarenko.png" alt="img">
                                </div>

                                <div class="excursions-section__author__title">
                                    <span class="excursions-section__author__name">Бондаренко Сергей Валентинович</span>
                                    <span class="excursions-section__author__personality">Депутат Совета депутатов г.Новосибирска</span>
                                </div>
                            </div>
                        </div>

                        <div class="excursions-section--btn-wrapper">
                            <a class="btn btn--w100 btn--main-bg btn--middle" @click="routeToLink('http://digitaltour.tilda.ws/beltopol')">Узнать больше</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'WelcomeExcursions',
    methods: {
        routeToLink(link) {
            window.open(link);
        },
    },
}
</script>
